import { Directive, ElementRef, HostListener, Input, OnInit, Self, OnDestroy} from "@angular/core";
import { Subscription } from 'rxjs';
import { NgControl } from '@angular/forms';
import { isNullOrUndefined } from './objectUtils';

//@Pipe({ name: 'percentage' })

@Directive({
    selector: "percentage input[percentage] input[ngModel]",
    standalone: false
})

export class PercentageDirective implements OnInit, OnDestroy{

  private el: HTMLInputElement;
  private modelSubscription: Subscription;
  private isFocused = false;
  public parametersObject: percentageDirectiveParameters;

  protected maxValue: string;

  constructor(
    protected elementRef: ElementRef,
    @Self() protected control: NgControl,
    //@Self() protected PercentageDirective: PercentageDirective,
  ) {
    this.parametersObject = new percentageDirectiveParameters();
    this.el = this.elementRef.nativeElement;

    this.modelSubscription = this.control.valueChanges
      .subscribe(value => {
        if (!this.isFocused)
          this.el.value = this.checkRegex(this.control.value, this.parametersObject);
      });
  
  /*
  transform(value: number | string, digitsInfo?: string, locale?: string): string | null;
  transform(value: null | undefined, digitsInfo?: string, locale?: string): null;
  transform(value: number | string | null | undefined, digitsInfo?: string, locale?: string): string | null {
    //const str = super.transform(value, digitsInfo, locale);
    return (str === null || str === undefined || str.length === 0) ? '' : str + '%';
    */
  }

  ngOnDestroy(): void {
    if (this.modelSubscription != null)
      this.modelSubscription.unsubscribe();
  }

  ngOnInit() {
    
  }


  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    if ([46, 8, 9, 27, 13, 188, 189, 109, 110, 190 ].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+V
      (e.keyCode == 86 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39) ||
      // Allow: numbers
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      // Allow: NumPad Numbers
      (e.keyCode >= 96 && e.keyCode <= 105)) {
      // let it happen, don't do anything
      return;
    }
    else {
      e.preventDefault();
    }
  }

  @HostListener('keyup', ['$event']) onKeyUp(event) {
    let e = <KeyboardEvent>event
    if ([110, 190].indexOf(e.keyCode) !== -1) {
      var position = Number(event.target.selectionStart);
      this.el.value = this.el.value.replace(/\./g, ",");
      event.target.setSelectionRange(position, position);
    }
  }
  
  @HostListener("focus")
  onFocus() {
    this.isFocused = true;
  }

  @HostListener("blur")
  onBlur() {
   
    this.el.value = this.checkRegex(this.control.value, this.parametersObject);
    this.isFocused = false;
    if (this.control != undefined && this.control != null && this.control.control != undefined && this.control.control != null) {
      this.control.control.setValue(this.el.value.replace(/\,/g, ".").replace(/ /g, ""));
    }
  }
  /*
  @HostListener('keyup', ['$event']) onKeyUp(event) {
    var newValue = this.el.value;
    var position = this.el.selectionStart;
    var isBackSpace;
    if (newValue.substr(newValue.length - 1, 1) == "," && newValue.length > 1) {
      if (this.checkRegex(newValue.substr(0, newValue.length - 1))) {
        this.parametersObject.currentValue = newValue;
      }
      else {
        this.el.value = this.parametersObject.currentValue;
        isBackSpace = event.keyCode == 8 ? 0 : 1;
        this.el.selectionStart = position - isBackSpace;
        this.el.selectionEnd = position - isBackSpace;
      }
    }
    else {
      if (this.checkRegex(newValue)) {
        this.parametersObject.currentValue = newValue;
      }
      else {
        isBackSpace = event.keyCode == 8 ? 1 : -1;
        this.el.value = this.parametersObject.currentValue;
        this.el.selectionStart = position + isBackSpace;
        this.el.selectionEnd = position + isBackSpace;
      }
    }

    this.isFocused = false;
  }
  */

  private PercentageFormat(inputString) {
    if (isNullOrUndefined(inputString)) {
      inputString = "";
    }
    else {
      inputString = inputString.toString();
      inputString = inputString.replace(/ /g, "");
      inputString = inputString.replace(/\./g, ",");
    }

    var decimalPart = "";
    if (inputString.indexOf(',') != -1) {
      inputString = inputString.split(",");
      decimalPart = "," + (inputString[1] == "" ? "00" : (inputString[1] + "00").substring(0, 2));
      inputString = inputString[0];
    }
    else {
      decimalPart = inputString == "" ? "" : ",00";
    }
    var outputString = "";
    var count = 0;
    for (var i = inputString.length - 1; i >= 0 && inputString.charAt(i) != '-'; i--) {
      if (count == 3) {
        outputString += " ";
        count = 0;
      }
      outputString += inputString.charAt(i);
      count++;
    }
    if (inputString.charAt(0) == '-') {
      outputString += "-";
    }

    return outputString.split("").reverse().join("") + decimalPart;
  }

  private checkRegex(newValue: any, parameters: percentageDirectiveParameters) {
    if (isNullOrUndefined(newValue))
      this.parametersObject.currentValue = "";
    else {
      newValue = this.PercentageFormat(newValue);

      if (RegExp(this.parametersObject.regexRule).test(newValue)) {
        this.parametersObject.currentValue = newValue;
      }
    }
    return this.parametersObject.currentValue;
  }
  /*
  private checkRegex(newValue: any) {
    if (isNullOrUndefined(newValue)) {
      this.parametersObject.currentValue = "";
      return true;
    }
    else {
      return RegExp(this.parametersObject.regexRule).test(newValue);
    }
  }*/
}

class percentageDirectiveParameters {
  public regexRule: string = "(^100(\\,0{1,2})?$)|(^([1-9]([0-9])?|0)(\\,[0-9]{1,2})?$)";
  public integerPlaces: number = 3;
  public decimalPlaces: number = 2;
  public hasSign: boolean = false;
  public currentValue = "";
}
